import { RouteRecordRaw } from 'vue-router';

export const companyRoutes: RouteRecordRaw[] = [
  {
    path: '/company',
    name: 'CompanySettings',
    component: () => import('@/pages/company/CompanySettingsPage.vue'),
    children: [
      {
        path: 'users',
        name: 'CompanyUsers',
        component: () => import('@/pages/company/CompanyUsersPage.vue'),
        children: [
          {
            path: 'new',
            name: 'CompanyNewUser',
            component: () => import('@/pages/company/CompanyNewUserPage.vue'),
          },
          {
            path: ':userid',
            name: 'CompanyUser',
            component: () => import('@/pages/company/CompanyUserPage.vue'),
          },
        ],
      },
      {
        path: 'scopes',
        name: 'CompanyScopes',
        component: () => import('@/pages/company/CompanyScopesPage.vue'),
      },
      {
        path: 'projects',
        name: 'CompanyProjects',
        component: () => import('@/pages/company/CompanyProjectsPage.vue'),
      },
      {
        path: 'templates',
        name: 'CompanyTemplates',
        component: () => import('@/pages/company/CompanyTemplatesPage.vue'),
      },
      {
        path: 'project-properties',
        name: 'CompanyProjectProperties',
        component: () => import('@/pages/company/CompanyProjectProperties.vue'),
      },
      {
        path: 'analytics',
        name: 'CompanyAnalytics',
        component: () => import('@/pages/company/CompanyAnalyticsPage.vue'),
      },
      {
        path: 'volatility',
        name: 'CompanyVolatility',
        component: () => import('@/pages/company/CompanyVolatilityPage.vue'),
      },
      {
        path: 'content',
        name: 'CompanyInAppContent',
        component: () => import('@/pages/company/CompanyInAppContentPage.vue'),
      },
      {
        path: 'quality-checks',
        name: 'CompanyQualityChecks',
        component: () => import('@/pages/company/CompanyQualityChecksPage.vue'),
      },
      {
        path: 'ai-skills',
        name: 'CompanyAiSkills',
        component: () => import('@/pages/company/CompanyAiSkillsPage.vue'),
      },
      {
        path: 'ai-models',
        name: 'CompanyAiModels',
        component: () => import('@/pages/company/CompanyAiModelsPage.vue'),
      },
      {
        path: 'ai-glossary',
        name: 'CompanyAiGlossary',
        component: () => import('@/pages/company/CompanyAiGlossaryPage.vue'),
      },
    ],
  },
];
